// extracted by mini-css-extract-plugin
export var text = "_at-0";